// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"DO-z","inlineTitle":"EO-z","sponsoredAdsWrapper":"FO-z","marketplaceRecosWrapper":"GO-z"};